export type MetricDefinition = {
  id: string;
  metricName: string;
  definition: string;
  calculation: string;
  longDefinition: string;
  learnMoreLink: string;
  createdAt: number;
  updatedAt: number;
  isMIReportingMetric: boolean;
  isCAReportingMetric?: boolean;
};

export type Metric = {
  metricName: string;
  metricNiceName: string;
  category: string | null;
  valueType: string;
  mediums: string[];
  metrics?: { metricName: string }[];
};

export enum PDFReportType {
  MESSAGING_INSIGHTS = 'MESSAGING_INSIGHTS_REPORT',
}
